import React from 'react';

function SavedRecipesView({ savedRecipes, onViewRecipe, onDeleteRecipe, onNewRecipe }) {
  return (
    <main className="main-container">
      <div className="page-title">
        <h1>Saved Recipes</h1>
        <p>
          {savedRecipes.length === 0
            ? 'No recipes saved yet'
            : `${savedRecipes.length} recipe${savedRecipes.length > 1 ? 's' : ''} saved`}
        </p>
      </div>

      {savedRecipes.length === 0 ? (
        <div className="empty-state card">
          <div className="empty-icon">&#128221;</div>
          <p className="empty-title">Nothing here yet</p>
          <p className="empty-hint">Calculate a recipe and tap "Save Recipe" to keep it here.</p>
          <button className="btn btn-primary" style={{ marginTop: '20px' }} onClick={onNewRecipe}>
            + New Recipe
          </button>
        </div>
      ) : (
        savedRecipes.map(recipe => (
          <div className="saved-card card" key={recipe.id}>
            <div className="saved-card-top">
              <div className="saved-card-name">{recipe.name}</div>
              <div className="saved-card-date">{recipe.savedAt}</div>
            </div>

            <div className="saved-stats">
              <div className="saved-stat">
                <div className="saved-stat-value">&#8377;{recipe.costPerUnit}</div>
                <div className="saved-stat-label">per unit</div>
              </div>
              <div className="saved-stat-divider" />
              <div className="saved-stat">
                <div className="saved-stat-value">{recipe.totalUnit}</div>
                <div className="saved-stat-label">units</div>
              </div>
              <div className="saved-stat-divider" />
              <div className="saved-stat">
                <div className="saved-stat-value">&#8377;{recipe.cost}</div>
                <div className="saved-stat-label">total cost</div>
              </div>
              <div className="saved-stat-divider" />
              <div className="saved-stat">
                <div className="saved-stat-value">{recipe.yeild}g</div>
                <div className="saved-stat-label">yield</div>
              </div>
            </div>

            <div className="saved-card-actions">
              <button className="btn btn-secondary" onClick={() => onViewRecipe(recipe)}>
                View Breakdown
              </button>
              <button className="btn btn-danger" onClick={() => onDeleteRecipe(recipe.id)}>
                Delete
              </button>
            </div>
          </div>
        ))
      )}
    </main>
  );
}

export default SavedRecipesView;
